export default "__VITE_ASSET__DgRQWick__"